module.exports = __webpack_public_path__ + "img/ticket_tw1.fc36d894.png";